import { render, staticRenderFns } from "./BatchSamplesBatchConfirmation.vue?vue&type=template&id=f6f23a4c&scoped=true"
import script from "./BatchSamplesBatchConfirmation.vue?vue&type=script&lang=js"
export * from "./BatchSamplesBatchConfirmation.vue?vue&type=script&lang=js"
import style0 from "./BatchSamplesBatchConfirmation.vue?vue&type=style&index=0&id=f6f23a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f23a4c",
  null
  
)

export default component.exports